<template>
    <div class="temp-container">
        <div class="flex" style="height: 2600px">
            <div class="preview-container">
                <div
                        class="preview-wrapper"
                        :style="{
            backgroundColor: pageConfig.bg,
            backgroundImage: 'url(' + pageConfig.bg + ')'
          }"
                >
                    <div
                            class="preview-head"
                            :style="{ backgroundImage: 'url(' + pageConfig.topBgImg + ')' }"
                    >
                        <div
                                class="head-ipt-wrapper"
                                v-if="scrollGt100 && pageConfig.isShowSearchBox"
                        >
                            <input type="text" placeholder="搜索商品" />
                        </div>
                        <div
                                class="preview-title"
                                :style="{ color: pageConfig.titleColor }"
                                :class="{ bold: pageConfig.titleBold }"
                                v-else
                        >
                            {{ title }}
                        </div>
                    </div>
                    <div ref="scrollbar">
                        <div class="preview-body">
                            <draggable
                                    class="dragArea preview-list-group"
                                    :list="previewComponents"
                                    group="component"
                                    @change="log"
                            >
                                <div
                                        class="preview-list-group-item"
                                        @click="selectPreviewItem(i, v.prop)"
                                        :class="{
                    active: activePreviewIndex === i,
                    'contact-us-item': v.component === 'contact-us'
                  }"
                                        v-for="(v, i) in previewComponents"
                                        :key="i"
                                        v-if="v.component != 'search'"
                                >
                                    <component
                                            :is="v.component"
                                            :random="Math.random()"
                                            :key="'component' + i"
                                            ref="singleComponent"
                                            :isActive="activePreviewIndex === i"
                                            :controls="v.component === 'video'"
                                            v-bind="v.prop"
                                    ></component>
                                </div>
                            </draggable>
                        </div>
                    </div>
                    <hot-map v-if="hotMapTime.startTime && hotMapTime.endTime" style="position: absolute; top: 0" :visitPv="hotMapData[0].visitPv" :hot-map-time="hotMapTime" :key="timerMap"></hot-map>
                </div>
            </div>
            <div style="width: 100%; height: 2600px; background: #fff;padding-top: 10px;" class="flex flex-end flex-column">
                <div style="margin-left: auto;">
                        <el-radio-group  class="mr10" v-model="selectHotMapData" @change="changeTag">
                            <el-radio-button label="yesterday">昨天</el-radio-button>
                            <el-radio-button label="formerlyEven">过去3天</el-radio-button>
                        </el-radio-group>
                </div>
                    <el-table style="width: 1000px; margin-top: 20px; margin-left: auto;"
                        :data="hotMapData"
                    >
                        <el-table-column
                                align="center"
                                prop="spuVisitUv"
                                label="访客数"
                        ></el-table-column>
                        <el-table-column
                                align="center"
                                prop="visitPv"
                                label="浏览量"
                        ></el-table-column>
                        <el-table-column
                                align="center"
                                prop="clickPv"
                                label="点击次数"
                        ></el-table-column>
                        <el-table-column
                                align="center"
                                prop="clickUv"
                                label="点击人数"
                        ></el-table-column>
                        <el-table-column
                                align="center"
                                prop="ctr"
                                label="点击率"
                        ></el-table-column>
                        <el-table-column
                                align="center"
                                prop="jumpProbability"
                                label="页面跳出率"
                        ></el-table-column>
                    </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint vue/no-unused-components: [0] */
    import { getLoginUser } from "@/utils/auth";
    import { hmComponents, tabBarList, predefine } from "@/utils/tempData";
    import html2canvas from "html2canvas";
    import draggable from "vuedraggable";
    import myUpload from "vue-image-crop-upload";
    import HmUpload from "@/components/HmUpload";
    import HmRichEditor from "@/components/HmRichEditor";
    import tabBar from "@/components/HmMallComponent/tabBar";
    import search from "@/components/HmMallComponent/search";
    import notice from "@/components/HmMallComponent/notice";
    import contactUs from "@/components/HmMallComponent/contactUs";
    import dividingLine from "@/components/HmMallComponent/dividingLine";
    import richText from "@/components/HmMallComponent/richText";
    import titleText from "@/components/HmMallComponent/titleText";
    import imageAdSelection from "@/components/HmMallComponent/imageAdSelection";
    import imageTextNav from "@/components/HmMallComponent/imageTextNav";
    import goodsList from "@/components/HmMallComponent/goodsList";
    import coupon from "@/components/HmMallComponent/coupon";
    import groupon from "@/components/HmMallComponent/groupon";
    import seckill from "@/components/HmMallComponent/seckill";
    import bargain from "@/components/HmMallComponent/bargain";
    import singleExclusive from "@/components/HmMallComponent/singleExclusive";
    import live from "@/components/HmMallComponent/live";
    import guessYouLike from "@/components/HmMallComponent/guessYouLike";
    import tabs from "@/components/HmMallComponent/tabs";
    import cube from "@/components/HmMallComponent/cube";
    import HotZone from "@/components/hotZone/Hotzone";
    import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
    import HmFilterGroupGoods from "@/components/HmFilterGroupGoods";
    import HmFilterBrand from "@/components/HmFilterBrand";
    import HmFilterCoupon from "@/components/HmFilterCoupon";
    import HmFilterBargain from "@/components/HmFilterBargain";
    import HmFilterGroupon from "@/components/HmFilterGroupon";
    import HmFilterSeckill from "@/components/HmFilterSeckill";
    import HmFilterLive from "@/components/HmFilterLive";
    import HmFilterSingleExclusive from "@/components/HmFilterSingleExclusive";
    import { mapGetters } from "vuex";
    import hotMap from "@/views/collectionOrder/hotMap";
    import moment from 'moment'
    import {setCookie,getCookie} from "@/utils/utils";

    export default {
        name: "custom-clone",
        display: "Clone",
        order: 2,
        hotMapTime:{
            starTime:'',
            endTime:''
        },
        components: {
            hotMap,
            tabBar,
            draggable,
            tabs,
            search,
            contactUs,
            groupon,
            dividingLine,
            myUpload,
            HmUpload,
            notice,
            richText,
            HmRichEditor,
            titleText,
            imageAdSelection,
            imageTextNav,
            goodsList,
            cube,
            seckill,
            bargain,
            live,
            guessYouLike,
            singleExclusive,
            HmFilterMicroShopGoods,
            HmFilterGroupGoods,
            HmFilterBrand,
            HmFilterCoupon,
            HmFilterLive,
            HmFilterBargain,
            HmFilterGroupon,
            HmFilterSeckill,
            HmFilterSingleExclusive,
            HotZone,
            coupon
        },
        data() {
            return {
                timerMap:'',
                hotMapData:[{
                    spuVisitUv:0,
                    clickUv:0,
                    visitPv:0,
                    clickPv:0,
                    ctr:0,
                    jumpProbability:0
                }],
                selectHotMapData:'yesterday',
                selfTime:'',
                searchTime:{
                    startTime:'',
                    endTime:''
                },
                showUploadLocalVideo: false,
                maxUploadSize: "",
                pageConfig: {
                    fillBgType: "custom",
                    titleColor: "#2b2b2b",
                    titleBold: false,
                    topBgImg:
                        "https://imgcdn.hemiao100.com/hemiaoBase/a490012bc5491ffa93dc5a82fb3417e.png",
                    isShowSearchBox: true
                },
                isUploadVideo: false,
                imgAdSelectionUpLoadType: "leftImgList",
                selectLiveVisible: false,
                selectCouponVisible: false,
                selectBargainVisible: false,
                selectGrouponVisible: false,
                selectSeckillVisible: false,
                selectSingleExclusiveVisible: false,
                brandVisible: false,
                tabList: [],
                groupGoodsVisible: false,
                hmUploadVisible: false,
                isRadio: false,
                scrollGt100: false,
                goodsType: "",
                pageType: "",
                pageModel: "",
                layoutId: "",
                currentImageAd: "",
                currentIndex: "",
                currentParams: "",
                uploadType: "",
                uploadWidth: 20,
                uploadHeight: 20,
                predefine,
                showPageSetting: true,
                dialogVisible: false,
                show: false,
                title: "微页面标题",
                hotWord: "",
                activePreviewIndex: "",
                currentProp: {},
                currentTab: "",
                currentTabIconType: "",
                tabBarList,
                hmComponents,
                allComponents: [],
                previewComponents: [],
                currentLinkIndex: "",
                currentLinkPropName: "",
                selectGroupGoodsType: "",
                currentPage:1,
                pageSize:15,
                hotMapTime:{
                    startTime:'',
                    endTime:''
                },
            };
        },
        computed: mapGetters(["tempDetails", "microShopRouteList", "storeStyle"]),
        watch: {
            tempDetails(val) {
                this.title = val.pageTitle || "微页面标题";
                if (val.pageConfig) {
                    this.pageConfig = JSON.parse(val.pageConfig) || this.pageConfig;
                    if (!this.pageConfig.fillBgType) {
                        this.pageConfig.fillBgType = "custom";
                        this.pageConfig.bg = "#f5f5f5";
                    }
                }
                this.previewComponents = val.previewComponents
                    ? JSON.parse(val.previewComponents)
                    : [];
                console.log("this.previewComponents: ", this.previewComponents);
                this.previewComponents.forEach(v => {
                    if (v.component === "hotZone") {
                        v.prop.zonesInit = v.prop.zones;
                    }
                });
                if (val.tabBarList) {
                    this.tabBarList = JSON.parse(val.tabBarList);
                }
            },
            "currentProp.goodShowType": {
                handler(val) {
                    if (val) {
                        switch (val) {
                            case "big":
                                this.type = "大图";
                                break;
                            case "twoColumn":
                                this.type = "一行两个";
                                break;
                            case "scroll":
                                this.type = "横向滑动";
                                break;
                            default:
                                break;
                        }
                    }
                },
                deep: true
            },
            "currentProp.permutation": {
                handler(val) {
                    if (val) {
                        this.calcCubeList(val);
                    }
                },
                deep: true
            },
            "currentProp.type": {
                handler(val) {
                    console.log("val: ", val);
                    if (val) {
                        this.currentProp.url = "";
                    }
                },
                deep: true
            },
            "currentProp.isSwiper": {
                handler(val) {
                    if (val) {
                        this.currentProp.marginBottom = 0;
                    }
                },
                deep: true
            }

        },
        created() {
            this.pageType = this.$route.query.pageType;
            this.pageModel = this.$route.query.pageModel;
            this.mode = this.$route.query.mode;
            if (
                (this.pageModel === "customize" && this.layoutId) ||
                this.pageModel === "default"
            ) {
                const res = this.$store.dispatch("queryTempDetails", {
                    pageType: this.pageType,
                    pageModel: this.pageModel,
                });
                const that = this;
                Promise.resolve(res).then(function (result) {
                    let data = result.result.layoutId
                    setCookie({key:'layId',data});
                    let tabBarList = JSON.parse(result.result.tabBarList);
                    that.layoutId = data;
                    that.yesterdayFun();
                    console.log("tabBarList", tabBarList);
                });

            }
            this.queryCanUploadLocalVideo();
            this.$store.dispatch("queryMicroShopList", {
                pageType: "page"
            });
            this.$store.dispatch("queryStoreStyle");

        },
        mounted() {

        },
        methods: {
            //清空数据
            clear(){
                this.hotMapData[0].spuVisitUv = 0;
                this.hotMapData[0].clickUv = 0;
                this.hotMapData[0].visitPv = 0;
                this.hotMapData[0].clickPv = 0;
                this.hotMapData[0].ctr =0+ "%";
                this.hotMapData[0].jumpProbability = 0 + '%';
            },
            querySelectData(){
                this.clear();
                console.log(this.selfTime);
                this.searchTime.startTime = this.selfTime[0];
                this.searchTime.endTime = this.selfTime[1];
                this.visitList();
            },
            changeTag(){
                this.timerMap = new Date().getTime()
                if(this.selectHotMapData == "yesterday"){
                    this.yesterdayFun();
                }else if(this.selectHotMapData == "formerlyEven"){
                    this.formerlyEvenFun();
                }else if(this.selectHotMapData == "formerlyThreety"){
                    this.formerlyThreetyFun();
                };
            },
            //计算昨天的时间
            yesterdayFun(){
                const start =  moment().subtract(1, "days").startOf('day');
                const end =  moment().subtract(1, "days").endOf('day');
                this.searchTime.startTime = moment(start).format("YYYY-MM-DD HH:mm:ss");
                this.searchTime.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                this.hotMapTime.startTime = moment(start).format("YYYY-MM-DD HH:mm:ss");
                this.hotMapTime.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                console.log(this.searchTime.startTime + '-' +this.searchTime.endTime);
                console.log(this.hotMapTime.startTime + '-' +this.hotMapTime.endTime);
                this.visitList();
            },
            formerlyEvenFun(){
                const start =  moment().subtract(3, "days").startOf('day');
                const end =  moment().subtract(1, "days").endOf('day');
                this.searchTime.startTime = moment(start).format("YYYY-MM-DD HH:mm:ss");
                this.searchTime.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                this.hotMapTime.startTime = moment(start).format("YYYY-MM-DD HH:mm:ss");
                this.hotMapTime.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                console.log(this.searchTime.startTime + '-' +this.searchTime.endTime);
                console.log(this.hotMapTime.startTime + '-' +this.hotMapTime.endTime);
                this.visitList();
            },
            formerlyThreetyFun(){
                const start =  moment().subtract(1, "month").startOf('day');
                const end =  moment().subtract(1, "days").endOf('day');
                this.searchTime.startTime = moment(start).format("YYYY-MM-DD HH:mm:ss");
                this.searchTime.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                this.hotMapTime.startTime = moment(start).format("YYYY-MM-DD HH:mm:ss");
                this.hotMapTime.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                console.log(this.searchTime.startTime + '-' +this.searchTime.endTime);
                this.visitList();
            },
            //访问数据统计
            async visitList(){
                let params = {
                  pageId: this.layoutId
                }
                const searchTime = JSON.parse(JSON.stringify(this.searchTime));
                Object.assign(params, searchTime);
                const { result } = await this.$store.dispatch("dateCont",params);
                if(result !== null){
                    this.hotMapData[0].spuVisitUv = result.spuVisitUv;
                    this.hotMapData[0].clickUv = result.clickUv;
                    this.hotMapData[0].visitPv = result.visitPv;
                    this.hotMapData[0].clickPv = result.clickPv;
                    this.hotMapData[0].ctr = result.visitPv && result.visitPv != 0 ? Math.floor(((result.clickUv/result.visitPv)*100)) + "%" : "0%";
                    this.hotMapData[0].jumpProbability = result.spuVisitUv && result.spuVisitUv != 0 ? Math.floor((1-result.clickUv/result.spuVisitUv)*100) + '%' : "0%";
                }else{
                    this.clear();
                }

            },
            changePageBg() {
                this.pageConfig.bg = "";
                this.$forceUpdate();
            },
            changePageBgImage() {
                this.hmUploadVisible = true;
                this.uploadType = "pageConfigBg";
            },
            changeBgColor() {
                this.$forceUpdate();
            },
            async queryCanUploadLocalVideo() {
                const { storeCode } = getLoginUser();
                const { result } = await this.$store.dispatch(
                    "queryStoreInterFaceTextInfo",
                    {
                        code: "uploadVideo",
                        storeCode
                    }
                );
                if (result) {
                    this.showUploadLocalVideo = true;
                    this.maxUploadSize = result.value;
                }
            },
            changeVideoType() {
                this.currentProp.src = "";
            },
            upLoadVideo() {
                this.isUploadVideo = true;
                this.uploadType = "video";
                this.hmUploadVisible = true;
            },
            handleAddZone(zone) {
                if (this.currentProp.zones) {
                    this.$set(zone, "goodsInfo", {});
                    this.$set(zone, "hrefAddress", "");
                    this.$set(zone, "groupGoods", {});
                    this.$set(zone, "appid", "");
                    this.$set(zone, "couponList", []);
                    this.currentProp.zones.push(zone);
                    this.currentProp.zonesInit = this.currentProp.zones;
                }
            },
            handleRemoveZone(index) {
                if (this.currentProp.zones) {
                    this.currentProp.zones.splice(index, 1);
                    this.currentProp.zonesInit = this.currentProp.zones;
                }
            },
            handleChangeZone() {},
            uploadHotZoneImage() {
                this.uploadType = "hotZoneImage";
                this.hmUploadVisible = true;
            },
            switchImageAdTemp(type) {
                if (type === "3") {
                    this.imgAdSelectionUpLoadType = "leftImgList";
                    if (this.currentProp.imgList.length) {
                        this.currentProp.leftImgList = this.currentProp.imgList;
                    } else {
                        this.currentProp.leftImgList = [];
                    }

                    if (!this.currentProp.rightImgList) {
                        this.currentProp.rightImgList = [];
                    }
                } else {
                    if (this.currentProp.leftImgList.length) {
                        this.currentProp.imgList = this.currentProp.leftImgList;
                    }
                }
                this.$forceUpdate();
            },
            changeCouponBg() {
                this.hmUploadVisible = true;
                this.uploadType = "coupon";
            },
            saveLive(data) {
                this.currentProp.liveList = data;
                console.log(this.currentProp.liveList);
                this.selectLiveVisible = false;
            },
            addLiveRoom() {
                this.selectLiveVisible = true;
            },
            saveCoupon(data) {
                if (this.selsectCouponType === "coupon") {
                    this.currentProp.couponList = data;
                } else if (this.selsectCouponType === "HotZone") {
                    this.currentProp[this.currentLinkPropName][
                        this.currentLinkIndex
                        ].couponList = data;
                    console.log("data: ", data);
                    console.log("this.currentLinkIndex: ", this.currentLinkIndex);
                    console.log("this.currentLinkPropName: ", this.currentLinkPropName);
                }
                this.selectCouponVisible = false;
            },
            saveSeckill(data) {
                this.selectSeckillVisible = false;
                this.currentProp.seckillList = data;
            },
            saveBargain(data) {
                this.selectBargainVisible = false;
                this.currentProp.bargainList = data;
            },
            saveSingleExclusive(data) {
                this.selectSingleExclusiveVisible = false;
                this.currentProp.singleExclusiveList = data;
            },
            saveGroupon(data) {
                this.selectGrouponVisible = false;
                this.currentProp.grouponList = data;
            },
            addCoupon(type) {
                this.selsectCouponType = type;
                this.selectCouponVisible = true;
            },
            addGroupon() {
                this.selectGrouponVisible = true;
            },
            addSingleExclusive() {
                this.selectSingleExclusiveVisible = true;
            },
            addBargain() {
                this.selectBargainVisible = true;
            },
            addSeckill() {
                this.selectSeckillVisible = true;
            },
            changeCouponColorType() {
                this.currentProp.couponColor = "";
            },
            changeCouponFillType() {
                this.currentProp.bg = "";
            },
            addTabsGroupGoods(i) {
                this.groupGoodsVisible = true;
                this.selectGroupGoodsType = "tabs";
                this.currentIndex = i;
            },
            addTabNav() {
                this.currentProp.tabList.push({
                    tabTitle: "",
                    appid: "",
                    hrefAddress: "",
                    groupGoods: {}
                });
            },
            deleteCurrentTabs(i) {
                this.currentProp.tabList.splice(i, 1);
                this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
            },
            handleCloseGroup(prop, index) {
                if (!index && index !== 0) {
                    this.currentProp.groupGoods = {};
                    this.currentProp.hrefAddress = "";
                } else {
                    this.currentProp[prop][index].groupGoods = {};
                    this.currentProp[prop][index].hrefAddress = "";
                }
            },
            saveGroupGoods(row) {
                this.groupGoodsVisible = false;
                if (!this.selectGroupGoodsType) {
                    if (!this.currentIndex && this.currentIndex !== 0) {
                        this.currentProp.groupGoods = row;
                    } else {
                        this.currentProp[this.currentParams][
                            this.currentIndex
                            ].groupGoods = row;
                        this.currentIndex = "";
                        this.currentParams = "";
                    }
                } else if (this.selectGroupGoodsType === "tabBarList") {
                    this.tabBarList[this.currentIndex].groupGoods = row;
                    this.currentIndex = "";
                    this.selectGroupGoodsType = "";
                } else if (this.selectGroupGoodsType === "tabs") {
                    this.currentProp.tabList[this.currentIndex].groupGoods = row;
                    this.$refs.singleComponent[this.activePreviewIndex].changeTab(
                        this.currentIndex
                    );
                    this.currentIndex = "";
                    this.selectGroupGoodsType = "";
                }
            },
            saveBrand(row) {
                this.brandVisible = false;
                if (this.currentLinkIndex !== -1) {
                    this.currentProp[this.currentLinkPropName][
                        this.currentLinkIndex
                        ].brandInfo = row;
                } else {
                    this.currentProp.brandInfo = row;
                }
                this.brandVisible = false;
            },
            // async queryGroupGoods(groupId) {
            //   const { storeCode } = getLoginUser();
            //   const { result } =  await this.$store.dispatch('queryGroupGoods', {
            // 			pageSize: 99999,
            // 			pageNo: 1,
            //       storeCode,
            // 			groupId,
            //   })
            //   const { records } = result
            //   this.$refs.singleComponent[this.activePreviewIndex].goodsList = records
            // },
            selectGroup(e, i, param) {
                if (e === "groupGoods") {
                    this.groupGoodsVisible = true;
                    if (i || i === 0) {
                        this.currentIndex = i;
                        this.currentParams = param;
                    }
                }
            },
            handleCloseTabsGroup(i) {
                this.currentProp.tabList[i].groupGoods = {};
                this.$refs.singleComponent[this.activePreviewIndex].goodsList = [];
            },
            handleCloseTabBarGroup(i) {
                this.tabBarList[i].groupGoods = {};
            },
            selectTabBarGroup(e, i) {
                if (e === "groupGoods") {
                    this.groupGoodsVisible = true;
                    this.selectGroupGoodsType = "tabBarList";
                    this.currentIndex = i;
                }
            },
            cancleUpload() {
                this.hmUploadVisible = false;
                this.isUploadVideo = false;
            },
            hmUploadSuccess(url) {
                this.isUploadVideo = false;
                switch (this.uploadType) {
                    case "imageAd":
                        if (this.currentProp.type !== "3") {
                            this.currentProp.imgList[this.currentImageAd].src = url;
                        } else {
                            this.currentProp[this.imgAdSelectionUpLoadType][
                                this.currentImageAd
                                ].src = url;
                        }
                        break;
                    case "cube":
                        this.currentProp.cubeList[this.currentImageAd].src = url;
                        break;
                    case "coupon":
                        this.currentProp.bg = url;
                        break;
                    case "hotZoneImage":
                        this.currentProp.image = url;
                        break;
                    case "video":
                        this.currentProp.src = url;
                        break;
                    case "topBgImg":
                        this.pageConfig.topBgImg = url;
                        break;
                    case "pageConfigBg":
                        this.pageConfig.bg = url;
                        break;
                    default:
                        break;
                }
                this.hmUploadVisible = false;
                this.$forceUpdate();
            },
            setLink(row) {
                if (this.currentLinkIndex !== -1) {
                    this.currentProp[this.currentLinkPropName][
                        this.currentLinkIndex
                        ].goodsInfo = row;
                    this.currentProp[this.currentLinkPropName][
                        this.currentLinkIndex
                        ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
                } else {
                    this.currentProp.goodsInfo = row;
                    this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
                }
                this.dialogVisible = false;
                this.isRadio = false;
            },
            handleClose(v) {
                v.goodsInfo = {};
                v.couponList = [];
                v.appid = "";
                v.brandInfo = {};
                v.hrefAddress = "";
                v.pageType = "";
            },
            openGoodsSelect(v, i, propName) {
                if (v.pageType === "goods") {
                    this.dialogVisible = true;
                    this.isRadio = true;
                    this.currentLinkIndex = i;
                    this.currentLinkPropName = propName;
                }
                if (v.pageType === "brand") {
                    this.brandVisible = true;
                    this.currentLinkIndex = i;
                    this.currentLinkPropName = propName;
                }

                if (v.pageType === "coupon") {
                    this.currentLinkIndex = i;
                    this.currentLinkPropName = propName;
                }
                v.groupGoods = {};
                v.goodsInfo = {};
                v.couponList = [];
                v.hrefAddress = "";
                v.appid = "";
                v.brandInfo = {};
            },
            openGoodsSelectSingle() {
                if (this.currentProp.pageType === "goods") {
                    this.dialogVisible = true;
                    this.isRadio = true;
                    // 为-1表示设置单个
                    this.currentLinkIndex = -1;
                }
                if (this.currentProp.pageType === "brand") {
                    this.brandVisible = true;
                    // 为-1表示设置单个
                    this.currentLinkIndex = -1;
                }
                this.currentProp.goodsInfo = {};
                this.currentProp.brandInfo = {};
                this.currentProp.groupGoods = {};
                this.currentProp.hrefAddress = "";
                this.currentProp.appid = "";
            },
            handleCloseSingle() {
                this.currentProp.brandInfo = {};
                this.currentProp.goodsInfo = {};
                this.currentProp.hrefAddress = "";
                this.currentProp.pageType = "";
                this.currentProp.appid = "";
            },
            addGoods() {
                this.dialogVisible = true;
                this.isRadio = false;
            },
            saveGoods(data) {
                this.dialogVisible = false;
                this.currentProp.goodsList = this.currentProp.goodsList.filter(
                    v => !v.isMock
                );
                this.currentProp.goodsList.push(...data);
            },
            setHotword() {
                this.previewComponents[this.activePreviewIndex].prop.hotWordList = [
                    this.hotWord
                ];
            },
            deleteCurrentComponent(i) {
                console.log(99998);
                this.previewComponents.splice(i, 1);
                this.openPageSetting();
            },
            copyCurrentComponent(i) {
                const row = JSON.parse(JSON.stringify(this.previewComponents[i]));
                this.previewComponents.splice(i, 0, row);
            },
            deleteCurrentGoods(i) {
                this.currentProp.goodsList.splice(i, 1);
                if (this.currentProp.goodsList && !this.currentProp.goodsList.length) {
                    this.currentProp.goodsList.push({
                        spuMainPic:
                            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
                        wxshopSpuName: "这里显示商品标题",
                        subTitle: "这里显示商品描述，最多显示一行",
                        id: 1,
                        temp: true,
                        isMock: true,
                        wxshopPrice: 0,
                        markingPrice: 0,
                        saleNum: 999
                    });
                }
            },
            addHotWord() {
                this.currentProp.hotWordList.push({
                    word: ""
                });
            },
            setPlaceholder() {
                if (this.currentProp.hotWordList && this.currentProp.hotWordList.length) {
                    this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
                }
            },
            save() {
                this.previewComponents.forEach(v => {
                    if (v.component === "search") {
                        if (v.prop.hotWordList.length) {
                            v.prop.placeholder = v.prop.hotWordList[0].word;
                        } else {
                            v.prop.placeholder = "";
                        }
                    }
                });
                console.log("this.previewComponents: ", this.previewComponents);
                html2canvas(document.querySelector(".preview-wrapper"), {
                    useCORS: true,
                    backgroundColor: null
                }).then(canvas => {
                    const previewImg = canvas.toDataURL("image/png");
                    const params = {
                        pageType: this.pageType,
                        pageTitle: this.title,
                        tabBarList: JSON.stringify(this.tabBarList),
                        previewComponents: JSON.stringify(this.previewComponents),
                        previewImg,
                        pageConfig: JSON.stringify(this.pageConfig)
                    };
                    let actionName = "";
                    if (this.pageModel === "default") {
                        actionName = "addTemp";
                    } else {
                        if (this.mode === "edit") {
                            Object.assign(params, {
                                micropageId: this.layoutId
                            });
                            actionName = "editTemp";
                        } else {
                            actionName = "addCustomTemp";
                        }
                    }
                    this.$store.dispatch(actionName, params).then(res => {
                        if (res.code === "0") {
                            this.$message({
                                type: "success",
                                message: "操作成功！"
                            });
                            this.$router.back(-1);
                        }
                    });
                });
            },
            back() {
                this.$confirm("退出将不会保存当前装修，确认退出?", "提示", {
                    cancelButtonText: "取消",
                    confirmButtonText: "确定",
                    type: "warning"
                }).then(() => {
                    this.$router.back();
                });
            },
            deleteCardList(i, prop) {
                this.currentProp[prop].splice(i, 1);
                if (prop === "hotWordList") {
                    if (
                        this.currentProp.hotWordList &&
                        this.currentProp.hotWordList.length
                    ) {
                        this.currentProp.placeholder = this.currentProp.hotWordList[0].word;
                    } else {
                        this.currentProp.placeholder = "";
                    }
                }
            },
            changeIcon(i, type) {
                this.uploadType = "navbar";
                this.uploadWidth = 40;
                this.uploadHeight = 40;
                this.show = true;
                this.currentTab = i;
                this.currentTabIconType = type;
            },
            setConcatImg() {
                this.uploadType = "contact";
                this.uploadWidth = 600;
                this.uploadHeight = 600;
                this.show = true;
            },
            changeImageTextNav(i) {
                this.uploadType = "imageTextNav";
                this.show = true;
                this.uploadWidth = 90;
                this.uploadHeight = 90;
                this.currentImageAd = i;
            },
            changeImageAd(i) {
                // if (this.currentProp.isSwiper) {
                //   this.uploadWidth = 1500;
                //   this.uploadHeight = 720;
                //   this.show = true;
                // } else {
                //   this.hmUploadVisible = true;
                // }
                this.hmUploadVisible = true;
                this.uploadType = "imageAd";
                this.currentImageAd = i;
            },
            setTopBgImg() {
                this.hmUploadVisible = true;
                this.uploadType = "topBgImg";
            },
            resetTopBgImg() {
                this.pageConfig.topBgImg =
                    "https://imgcdn.hemiao100.com/hemiaoBase/a490012bc5491ffa93dc5a82fb3417e.png";
            },
            changeCube(i) {
                this.uploadType = "cube";
                // this.show = true;
                // this.uploadWidth = 360;
                // this.uploadHeight = 360;
                this.hmUploadVisible = true;
                this.currentImageAd = i;
            },
            changeLogoUrl() {
                this.uploadType = "logoUrl";
                this.show = true;
                this.uploadWidth = 120;
                this.uploadHeight = 120;
            },
            cloneEnd(prop) {
                return JSON.parse(JSON.stringify(prop));
            },
            log(e) {
                if (e.added) {
                    this.activePreviewIndex = e.added.newIndex;

                    this.currentProp = {};
                    this.currentProp = e.added.element.prop;
                    this.recoveryData();
                } else if (e.moved) {
                    this.activePreviewIndex = e.moved.newIndex;
                    this.recoveryData();
                }
                this.showPageSetting = false;
                // if (this.currentProp.zones && !this.currentProp.zones.length) {
                //   this.$refs.singleComponent[this.activePreviewIndex].zones = [];
                // }
            },
            recoveryData() {},
            openPageSetting() {
                this.currentProp = {};
                this.activePreviewIndex = "";
                this.showPageSetting = true;
            },
            selectPreviewItem(i, prop) {
                console.log(i);
                console.log(prop);
                this.activePreviewIndex = i;
                this.currentProp = {};
                this.currentProp = prop;
                console.log("this.currentProp: ", this.currentProp);
                this.showPageSetting = false;
            },
            cropSuccess() {},
            toggleShow() {
                this.show = !this.show;
            },
            // 添加视频
            addVideoLink() {},
            // 添加底部导航栏
            addTabBarList() {
                this.tabBarList.push({
                    hrefName: "自定义",
                    open: true,
                    hrefAddress: "",
                    appid: "",
                    custom: true,
                    iconPath: "",
                    selectedIconpath: "",
                    groupGoods: {}
                });
            },
            // 添加图文导航
            addImageTextNav() {
                this.currentProp.imageTextNavList.push({
                    src:
                        "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
                    hrefAddress: "",
                    title: "导航",
                    appid: "",
                    goodsInfo: {},
                    groupGoods: {}
                });
            },
            // 添加图片广告
            addImageAd() {
                if (this.currentProp.type === "3") {
                    this.currentProp[this.imgAdSelectionUpLoadType].push({
                        src:
                            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
                        hrefAddress: "",
                        text: "",
                        appid: "",
                        goodsInfo: {},
                        groupGoods: {}
                    });
                } else {
                    this.currentProp.imgList.push({
                        src:
                            "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
                        hrefAddress: "",
                        text: "",
                        appid: "",
                        goodsInfo: {},
                        groupGoods: {}
                    });
                }
                this.$forceUpdate();
            },
            deleteCurrentImageAd(i) {
                this.currentProp.imgList.splice(i, 1);
                this.currentProp[this.imgAdSelectionUpLoadType].splice(i, 1);
            },
            calcCubeList(val) {
                let length = this.currentProp.cubeList
                    ? this.currentProp.cubeList.length
                    : 0;
                let list = JSON.parse(JSON.stringify(this.currentProp.cubeList));
                if (val < length) {
                    list = list.slice(0, val);
                } else if (val > length) {
                    for (let i = 0; i < val - length; i++) {
                        list.push({
                            src:
                                "https://imgcdn.hemiao100.com/hemiaoBase/66fba3d9-c379-4079-9496-2ff0b5c392c8.png",
                            url: "",
                            appid: "",
                            hrefAddress: "",
                            goodsInfo: {},
                            groupGoods: {}
                        });
                    }
                }
                this.currentProp.cubeList = list;
            },
            deleteCurrentCoupon(i, index) {
                this.currentProp.zones[i].couponList.splice(index, 1);
                this.$forceUpdate();
            },
            deleteCurrentImageTextNav(i) {
                this.currentProp.imageTextNavList.splice(i, 1);
            },
            cropUploadSuccess(jsonData) {
                const url = jsonData.result;
                switch (this.uploadType) {
                    case "navbar":
                        this.tabBarList[this.currentTab][this.currentTabIconType] = url;
                        break;
                    case "contact":
                        this.currentProp.url = url;
                        break;
                    case "imageAd":
                        this.currentProp.imgList[this.currentImageAd].src = url;
                        break;
                    case "imageTextNav":
                        this.currentProp.imageTextNavList[this.currentImageAd].src = url;
                        break;
                    case "cube":
                        this.currentProp.cubeList[this.currentImageAd].src = url;
                        break;
                    case "logoUrl":
                        this.currentProp.logoUrl = url;
                        break;
                    default:
                        break;
                }
            },
            deleteCurrentTabbar(i) {
                this.tabBarList.splice(i, i);
            },
            cropUploadFail() {}
        }
    };
</script>
<style lang="scss">
    .temp-container {
        .ql-editor {
            padding: 0;
        }
    }
    .image-ad-selection-upload {
        margin-bottom: 20px;
        .context {
            position: relative;
            height: 155px;
            width: 155px;
            border: 1px solid #ddd;
            text-align: center;
            background: #fafafa;
            &.active {
                border: 1px solid #e50065;
                background: #fdf1f6;
            }
            .el-radio {
                margin: 0;
            }
            .dot {
                position: absolute;
                bottom: 20px;
                left: 50%;
                transform: translateX(-50%);
                &.active {
                    .point {
                        background: #ffd4e7;
                        &.first {
                            background: #e50065;
                        }
                    }
                }
                .point {
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background: #ddd;
                    margin-right: 5px;
                }
            }
        }
    }
</style>
<style scoped lang="scss">
    .icon-wrapper {
        overflow: hidden;
    }
    .temp-container {
        .component-list {
            background: #fff;
            padding: 20px;
            width: 219px;
            box-sizing: border-box;
            .title {
                color: #ccc;
                font-size: 16px;
                margin-bottom: 31px;
            }
            .list-group {
                box-sizing: border-box;
            }
            .list-group-item {
                cursor: move;
                margin-bottom: 28px;
                width: 50%;
                text-align: center;
                padding: 10px;
                box-sizing: border-box;
                &:hover {
                    transition: all 0.2s linear;
                    background-color: #fddfeb !important;
                    border-radius: 2px;
                    color: rgb(226, 0, 93);
                    .label {
                        color: rgb(226, 0, 93);
                    }
                }
                .hmicon {
                    font-size: 24px;
                }
                .label {
                    margin-top: 16px;
                    font-size: 14px;
                    color: #666;
                }
            }
        }
        .preview-container {
            position: absolute;
            top: 20px;
            left: 20px;
            bottom: 0;
            user-select: none;
        }
        .preview-wrapper {
            position: relative;
            box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
            width: 375px;
            height: 667px;
            margin: 0 auto;
            .preview-head {
                height: 64px;
                width: 375px;
                margin: 0 auto;
                position: relative;
                background-size: contain;
                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: url("https://imgcdn.hemiao100.com/hemiaoBase/9673fc3dbf6810f0bb4d9e15ea5af07.png")
                    0/ 100% 100%;
                    z-index: 100;
                }
                .preview-title {
                    width: 180px;
                    margin: 0 auto;
                    height: 34px;
                    line-height: 26px;
                    text-align: center;
                    padding-top: 30px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .preview-body {
                position: relative;
                width: 375px;
                background-size: 100% 100%;
                .preview-list-group {
                    height: 603px;
                    .preview-list-group-item {
                        position: relative;
                        box-sizing: border-box;
                        cursor: move;
                        border: 2px solid transparent;
                        min-height: 20px;
                        .widget {
                            position: absolute;
                            top: 0;
                            right: -85px;
                            width: auto;
                            cursor: pointer;
                            z-index: 9;
                            .widget-label {
                                display: inline-block;
                                background-color: #fff;
                                width: 80px;
                                height: 24px;
                                text-align: center;
                                line-height: 24px;
                                font-size: 12px;
                                pointer-events: none;
                                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                            }
                            .widget-icon {
                                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
                                width: 40px;
                                height: 28px;
                                text-align: center;
                                font-size: 16px;
                                line-height: 28px;
                                background: #fff;
                                color: #e71370;
                                display: none;
                            }
                            &::before {
                                content: "";
                                width: 0;
                                height: 0;
                                border-width: 5px;
                                border-style: solid;
                                border-color: transparent #fff transparent transparent;
                                position: absolute;
                                bottom: 7px;
                                left: -10px;
                            }
                        }
                        &:hover {
                            .widget-icon {
                                display: block;
                                cursor: pointer;
                            }
                            .widget-label {
                                display: none;
                                cursor: pointer;
                            }
                        }
                        *:not(.widget-icon) {
                            cursor: move !important;
                        }
                        video {
                            min-height: 140px;
                            width: 100%;
                            display: block;
                        }
                        &:last-child {
                            margin-bottom: 50px;
                        }
                        &.active,
                        &.active:hover {
                            box-sizing: border-box;
                            border: 2px solid #ea5798;
                            cursor: move;
                        }
                        &:hover {
                            box-sizing: border-box;
                            border: 2px dashed #ea5798;
                            cursor: move;
                        }
                    }

                    .contact-us-item {
                        position: absolute;
                        bottom: 23px;
                        width: 100%;
                        z-index: 11;
                        left: 0;
                    }
                    .list-group-item {
                        transition: all 0.2s linear;
                        background-color: #fddfeb !important;
                        border-radius: 2px;
                        color: #e2005d;
                        text-align: center;
                        .label {
                            margin-top: 10px;
                        }
                    }
                }
                .preview-height-tag {
                    position: absolute;
                    left: -130px;
                    bottom: 0;
                    width: 130px;
                    display: -ms-flexbox;
                    display: flex;
                    color: #a2a2a2;
                    border-bottom: 1px solid #dedede;
                    .preview-height-tag-text {
                        padding-top: 4px;
                        font-size: 12px;
                    }
                }
            }
        }

        .options-container {
            width: 360px;
            position: absolute;
            top: 56px;
            box-sizing: border-box;
            padding-bottom: 100px;
            right: 0;
            overflow-x: hidden;
            overflow-y: auto;
            bottom: 0;
            z-index: 999;
            background: #fff;
            .p20 {
                padding: 20px;
            }
            .have-bg-wrapper {
                padding: 0 20px 20px;
                background: #fafafa;
            }
            .title {
                color: #2b2b2b;
                font-weight: 500;
                font-size: 18px;
                margin-bottom: 18px;
            }
            .tips {
                margin: 18px 0 20px;
                font-size: 12px;
                color: #777;
            }
            .sub-title {
                color: #2b2b2b;
                margin-bottom: 20px;
                font-size: 14px;
            }
            .page-header {
                padding: 20px;
                font-size: 14px;
                border-bottom: 1px solid #eee;
            }
            .page-footer {
                font-size: 14px;
                .sub-title {
                    background: #fff;
                    padding: 20px;
                }
            }
        }

        .border-bottom {
            border-bottom: 1px solid #eee;
        }

        .page-setting {
            .tabbar-setting .tabbar-setting-item .icon-wrapper {
                img {
                    width: 21px;
                }
            }

            .icon-wrapper {
                position: relative;
                width: 66px;
                height: 66px;
                line-height: 66px;
                text-align: center;
                border: 1px solid #ddd;
                margin-right: 10px;
                cursor: pointer;
                img {
                    width: auto;
                }
                &.no-bg {
                    background: #f0f0f0;
                }
                .change-icon {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    color: #fff;
                    text-align: center;
                    height: 24px;
                    line-height: 24px;
                    background: rgba(0, 0, 0, 0.8);
                }
            }
        }

        .page-setting-btn {
            position: absolute;
            right: 385px;
            top: 100px;
            width: 98px;
            height: 36px;
            text-align: center;
            font-size: 14px;
            background: #fff;
            border-radius: 2px;
            line-height: 36px;
            cursor: pointer;
            user-select: none;
            &.active {
                background: #e2005d;
                color: #fff;
                .hmicon {
                    color: #fff;
                }
            }
            .hmicon {
                margin-right: 5px;
            }
        }
        .temp-header {
            height: 56px;
            line-height: 56px;
            background: #e50065;
            color: #fff;
            padding: 0 22px;
            font-size: 16px;
            user-select: none;
            .hmicon {
                color: #fff;
                font-size: 18px;
                margin-right: 10px;
            }
            .btn {
                cursor: pointer;
            }
            .title {
                font-size: 18px;
            }
            .sub-title {
                font-size: 14px;
            }
            .header-list {
                li {
                    border-right: 1px solid #fff;
                    padding: 0 22px;
                }
                li:last-child {
                    padding-right: 0;
                    border-right: 0;
                }
            }
        }
        .tabbar-setting {
            background: #fafafa;
            padding: 20px;
            .tabbar-setting-item {
                position: relative;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
                padding: 10px;
                margin-bottom: 10px;
                .delete-tab {
                    position: absolute;
                    cursor: pointer;
                    font-size: 20px;
                    right: -12px;
                    top: -10px;
                    color: #fff;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    background: #bbb;
                    border-radius: 50%;
                    z-index: 2;
                    opacity: 0;
                    transition: all 0.2s linear;
                }
                &:hover {
                    .delete-tab {
                        opacity: 1;
                    }
                }
                .icon-wrapper {
                    position: relative;
                    width: 66px;
                    height: 66px;
                    line-height: 66px;
                    text-align: center;
                    border: 1px solid #ddd;
                    margin-right: 10px;
                    cursor: pointer;
                    img {
                        width: auto;
                    }
                    &.no-bg {
                        background: #f0f0f0;
                    }
                    .change-icon {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        color: #fff;
                        text-align: center;
                        height: 24px;
                        line-height: 24px;
                        background: rgba(0, 0, 0, 0.8);
                    }
                }
            }
        }
        .card-list {
            .card-list-item {
                position: relative;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
                padding: 10px;
                margin-bottom: 10px;

                &:hover {
                    .card-item-delete {
                        opacity: 1;
                    }
                }
                .card-item-delete {
                    position: absolute;
                    cursor: pointer;
                    font-size: 20px;
                    right: -12px;
                    top: -10px;
                    color: #fff;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    background: #bbb;
                    border-radius: 50%;
                    z-index: 2;
                    opacity: 0;
                    transition: all 0.2s linear;
                }
            }
        }

        .component-setting {
            font-size: 14px;
            .have-bg-wrapper {
                padding: 20px;
                background: #fafafa;
            }

            .title-text-setting {
                .other-setting {
                    padding: 20px;
                    border-bottom: 1px solid #eee;
                    li:last-child {
                        margin-bottom: 0;
                    }
                }
            }

            .shape {
                background: #fff;
                padding: 3px;
                width: 66px;
                height: 18px;
                box-shadow: 0px 0px 8px 0px rgba(226, 226, 226, 1);
                .content {
                    background: #ffeaf3;
                    height: 100%;
                    width: 100%;
                }
                &.radius {
                    .content {
                        border-radius: 30px;
                    }
                }
                &.active {
                    border: 1px solid #e50065;
                }
                &.blank.active {
                    border-top-left-radius: 3px;
                    border-bottom-left-radius: 3px;
                }
                &.line.active {
                    border-top-right-radius: 3px;
                    border-bottom-right-radius: 3px;
                }

                &.blank,
                &.line {
                    width: 48px;
                    height: 22px;
                    font-size: 14px;
                    text-align: center;
                    box-shadow: none;
                    &.active {
                        background: #ffeaf3;
                    }
                    .el-radio {
                        margin-right: 0;
                    }
                }
            }

            .cube-setting {
                .shape {
                    height: 50px;
                    .column {
                        background: #ffd4e7;
                        border: 1px dotted #ffdfed;
                        margin: 0 2px;
                        height: 100%;
                    }
                }
            }

            .goods-setting {
                .icon-wrapper {
                    position: relative;
                    width: 66px;
                    height: 66px;
                    line-height: 66px;
                    text-align: center;
                    border: 1px solid #ddd;
                    margin-right: 10px;
                    cursor: pointer;
                    .change-icon {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        color: #fff;
                        text-align: center;
                        height: 24px;
                        line-height: 24px;
                        background: rgba(0, 0, 0, 0.8);
                    }
                }
            }

            .image-ad-setting {
                .tabbar-setting {
                    .tabbar-setting-item {
                        cursor: move;
                    }
                }
                .tabbar-setting {
                    padding: 0;
                }
                .icon-wrapper {
                    img {
                        width: 100%;
                    }
                }
                .shape.no-swiper,
                .shape.double-swiper,
                .shape.swiper {
                    height: 43px;
                }
                .shape {
                    &.swiper {
                        position: relative;
                        &::before {
                            content: "\B7\B7\B7";
                            position: absolute;
                            left: 50%;
                            top: 25%;
                            -webkit-transform: translate(-50%);
                            transform: translate(-50%);
                            color: red;
                            font-size: 26px;
                        }
                    }
                    &.double-swiper {
                        .content {
                            position: relative;
                            width: 48%;
                            &::before {
                                content: "\B7\B7\B7";
                                position: absolute;
                                left: 50%;
                                top: 25%;
                                -webkit-transform: translate(-50%);
                                transform: translate(-50%);
                                color: red;
                                font-size: 26px;
                            }
                        }
                    }
                }
            }
            .other-setting {
                li {
                    margin-bottom: 20px;
                }
            }

            .coupon-setting {
                .item-setting {
                    padding: 0 20px 20px;
                    .shape {
                        height: 28px;
                        .content {
                            background-color: transparent;
                        }
                    }
                    .style1 {
                        .content {
                            background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c6e0a88dcb8ee9-c4c9-44bc-9343-b8754a1b26ad.png");
                            background-size: 100% 100%;
                        }
                    }
                    .style2 {
                        .content {
                            background-image: url("https://imgcdn.hemiao100.com/decoration/ps9addd5b82b7a6c1d-c4f4-419f-be3c-2dc65a83e0f6.png");
                            background-size: 100% 100%;
                        }
                    }
                    .style3 {
                        .content {
                            background-image: url("https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-18/1616036787315-d5de7760-567e-4d23.png");
                            background-size: 100% 100%;
                        }
                    }
                }

                .settings {
                    padding: 20px;

                    .label {
                        width: 80px;
                    }

                    .settings-item {
                        margin-bottom: 20px;
                    }
                }

                .icon-wrapper {
                    position: relative;
                    width: 66px;
                    height: 66px;
                    line-height: 66px;
                    text-align: center;
                    border: 1px solid #ddd;
                    margin-right: 10px;
                    cursor: pointer;
                    img {
                        width: auto;
                    }
                    &.no-bg {
                        background: #f0f0f0;
                    }
                    .change-icon {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        color: #fff;
                        text-align: center;
                        height: 24px;
                        line-height: 24px;
                        background: rgba(0, 0, 0, 0.8);
                    }
                }
            }

            .groupon-setting {
                &.live-setting {
                    .item-setting {
                        &.top {
                            .shape {
                                height: 63px;
                                width: 78px;
                                .content {
                                    background-color: transparent;
                                }
                            }
                            .style1 {
                                .content {
                                    background-image: url("https://imgcdn.hemiao100.com/decoration/ps28a3f76a87c4ea71-aa49-49c8-91fe-271b6aa55fe8.png");
                                    background-size: 100% 100%;
                                }
                            }
                            .style2 {
                                .content {
                                    background-image: url("https://imgcdn.hemiao100.com/decoration/ps1c2f72bb04859ac6-523f-4cc2-8868-7f509b9f551f.png");
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }
                }
                .item-setting {
                    padding: 0 20px 20px;
                    &.top {
                        .shape {
                            height: 63px;
                            width: 78px;
                            .content {
                                background-color: transparent;
                            }
                        }
                        .style1 {
                            .content {
                                background-image: url("https://imgcdn.hemiao100.com/decoration/ps4602ec0679358453-15b6-43eb-b277-28db9ef60203.png");
                                background-size: 100% 100%;
                            }
                        }
                        .style2 {
                            .content {
                                background-image: url("https://imgcdn.hemiao100.com/decoration/ps51c9331763e24077-91a4-4d34-ae73-93c4088413a4.png");
                                background-size: 100% 100%;
                            }
                        }
                        .style3 {
                            .content {
                                background-image: url("https://imgcdn.hemiao100.com/temp/42010216070190/2021-03-18/1616037303596-4ebf225b-f53a-4986.png");
                                background-size: 100% 100%;
                            }
                        }
                    }
                }

                .settings {
                    padding: 20px;

                    .label {
                        width: 80px;
                    }

                    .settings-item {
                        margin-bottom: 20px;
                    }
                }

                .icon-wrapper {
                    position: relative;
                    width: 66px;
                    height: 66px;
                    line-height: 66px;
                    text-align: center;
                    border: 1px solid #ddd;
                    margin-right: 10px;
                    cursor: pointer;
                    img {
                        width: auto;
                    }
                    &.no-bg {
                        background: #f0f0f0;
                    }
                    .change-icon {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        color: #fff;
                        text-align: center;
                        height: 24px;
                        line-height: 24px;
                        background: rgba(0, 0, 0, 0.8);
                    }
                }
            }
            .coupon-list {
                background: #fafafa;
                .coupon-item {
                    // overflow: hidden;
                    margin-bottom: 10px;
                    position: relative;
                    .delete-tab {
                        position: absolute;
                        cursor: pointer;
                        font-size: 20px;
                        right: -12px;
                        top: -10px;
                        color: #fff;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        background: #bbb;
                        border-radius: 50%;
                        z-index: 2;
                        opacity: 0;
                        transition: all 0.2s linear;
                    }
                    &:hover {
                        .delete-tab {
                            opacity: 1;
                        }
                    }
                }

                $baseWidth: 10px;

                .price-wrapper {
                    position: relative;
                    color: #fff;
                    width: 95px;
                    border-top-left-radius: 6px;
                    border-bottom-left-radius: 6px;
                    &::before {
                        position: absolute;
                        top: -($baseWidth / 2);
                        right: -($baseWidth / 2);
                        content: "";
                        width: $baseWidth;
                        height: $baseWidth;
                        border-radius: 50%;
                        background: #f4f4f4;
                    }
                    &::after {
                        position: absolute;
                        bottom: -($baseWidth / 2);
                        right: -($baseWidth / 2);
                        content: "";
                        width: $baseWidth;
                        height: $baseWidth;
                        border-radius: 50%;
                        background: #f4f4f4;
                    }
                }
                .price {
                    font-size: 24px;
                    color: #fff;
                    &::before {
                        content: "￥";
                        font-size: 10px;
                    }
                }
                .discount {
                    font-size: 24px;
                    color: #fff;
                    &::before {
                        content: "折";
                        font-size: 10px;
                    }
                }
                .info {
                    background: #fff;
                    padding: 15px;
                    border-top-right-radius: 6px;
                    border-bottom-right-radius: 6px;
                }
                .valid-time {
                    font-size: 11px;
                    color: #606060;
                }
                .btn {
                    width: 80px;
                    height: 24px;
                    margin-top: 8px;
                    line-height: 24px;
                    background: rgba(247, 43, 43, 1);
                    border-radius: 12px;
                    color: #fff;
                    font-size: 13px;
                    border: none;
                }
            }
        }
    }

    .setting-list {
        .title {
            margin-right: 20px;
        }
    }

    .link-wrapper {
        padding: 0 20px 20px;
    }

    .warning {
        color: #e50163;
    }

    .hotzone-img-wrapper {
        position: relative;
        width: 100px;
        margin-bottom: 20px;
        padding-top: 20px;
        &.join-bg {
            img {
                min-height: auto;
            }
        }
        img {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            width: 100%;
        }
        .tip {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            font-size: 14px;
            box-sizing: border-box;
            padding: 10px 0;
            text-align: center;
        }
    }

    .top-bg-wrapper {
        position: relative;
        margin: 0 auto;
        width: 234px;
        padding-top: 20px;
        border: 1px dotted #ddd;

        &:hover {
            .contorl-wrapper {
                display: block;
            }
        }

        .contorl-wrapper {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            font-size: 14px;
            box-sizing: border-box;
            padding: 10px 0;
            text-align: center;
        }

        &.join-bg {
            img {
                min-height: auto;
            }
        }
        img {
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            width: 100%;
            min-height: 150px;
        }
    }

    .head-ipt-wrapper {
        border-radius: 30px;
        padding-top: 28px;
        padding-left: 20px;
        input {
            border-radius: 30px;
            border: 1px solid #efefef;
            padding-left: 20px;
            height: 28px;
        }
        ::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #999;
            font-size: 12px;
        }
    }
</style>
